import { ComponentF } from "../../../ui/ui";
import { withColor } from "../../../ui/uiText";
import { Target, TargetTypes } from "../../abilities/Target";
import { Spell } from "../../actors/Spell";
import { getMissingRequirements } from "../../actors/spellUtils";
import Colors from "../../Colors";
import { gameData } from "../../GameManager";

export const targetTypeLabel = (target: Target) => {
  switch (target.type) {
    case TargetTypes.SELF:
      return ["Self", Colors.AQUA_3];
    case TargetTypes.TARGET:
      return ["Ground", Colors.GRAY_2];
    case TargetTypes.PIECE:
      return ["Letter", Colors.GRAY_3];
    default:
      return ["", Colors.GRAY_1];
  }
};

export const SpellDetailDisplay: ComponentF<{
  spell: Spell | null;
  missingRequirements: boolean;
}> = (C, { spell, missingRequirements }) => {
  if (spell === null) {
    return;
  }

  let y = C.bounds.y;

  C.display.drawText(C.bounds.x, y, spell.name, C.bounds.w - 1);
  y += 1;
  if (spell.listed) {
    C.display.drawText(
      C.bounds.x,
      y,
      `Uses: ${
        spell.uses ? `${spell.uses.current} / ${spell.uses.max}` : "unlimited"
      }`
    );
  } else {
    C.display.drawText(C.bounds.x, y, "Applied on Purchase");
  }
  y += 1;

  C.display.drawText(
    C.bounds.x,
    y,
    withColor(Colors.LIGHT_GRAY_1, spell.description || "")
  );

  y = C.bounds.y;
  if (spell.ability?.target) {
    const target = spell.ability.target;
    const [label, color] = targetTypeLabel(target);
    C.display.drawText(
      C.bounds.x + C.bounds.w - label.length,
      y,
      withColor(color, label)
    );
    y += 1;
    if (target.distance) {
      const label = `${target.distance} Range`;
      C.display.drawText(C.bounds.x + C.bounds.w - label.length, y, label);
      y += 1;
    }

    if (!spell.ability.advancesTurn) {
      C.display.drawText(
        C.bounds.x + C.bounds.w - 7, //7 is length of "Instant"
        y,
        `%c{${Colors.GRAY_2}}Instant%c{}`
      );
    }

    if (missingRequirements) {
      const results = getMissingRequirements(spell, gameData.player);
      if (results.length) {
        C.display.drawText(
          C.bounds.x, //7 is length of "Instant"
          C.bounds.y + C.bounds.h - 2,
          `%c{${Colors.RED}}Requires: ${getMissingRequirements(
            spell,
            gameData.player
          ).join(", ")}`
        );
      }
    }
  }
};
